import { i18n } from '@/i18n'
import { kebabCase } from 'lodash'
import { formatDate } from '@/helpers/date'
import { ActivityLogParser } from '@/parsers/activityLog'

export class CancellationActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'cancellation_date': 'date',
        'status': 'cancellationStatus',
    }

    static getLogDescriptionCreated (activityLog, data) {
        return `${data.causer} <b>${i18n.tc(`common.change-log.cancellation.someone-cancelled-something${activityLog.properties.attributes.cancellation_date ? '-per-date' : ''}`, 1, { something: i18n.tc('common.change-log.subject.this.contract', 1), cancellationDate: formatDate(activityLog.properties.attributes.cancellation_date) })}</b>`
    }

    static getLogDescriptionUpdated (activityLog, data) {
        if (activityLog.properties.attributes.cancellation_date && !activityLog.properties.attributes.status) {
            // Cancellation date only
            return `${data.causer} <b>${i18n.tc('common.change-log.cancellation.updated-cancellation-date', 1, { cancellationDate: formatDate(activityLog.properties.attributes.cancellation_date) })}</b>`
        } else {
            // Status only or Status and cancellation date
            return `${data.causer} <b>${i18n.tc(`common.change-log.cancellation.${kebabCase(activityLog.properties.attributes.status)}${activityLog.properties.attributes.cancellation_date ? '-per-date' : ''}`, 1, { ofSomething: i18n.tc('common.change-log.subject.of-this.contract', 1), cancellationDate: formatDate(activityLog.properties.attributes.cancellation_date) })}</b>`
        }
    }

    static hideLogDetailsUpdated = true
}
